import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_VALUE = "";

const initialState = {
  searchTerm: DEFAULT_VALUE,
  isOpen: false,
  activeIndex: 0,
  totalMatch: 0,
};

const findInPageSlice = createSlice({
  name: "findInPage",
  initialState,
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    openModal: (state, action) => {
      state.searchTerm = DEFAULT_VALUE;
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.searchTerm = DEFAULT_VALUE;
      state.isOpen = false;
    },
    next: (state, action) => {
      if (state.totalMatch > state.activeIndex + 1) {
        ++state.activeIndex;
      } else {
        state.activeIndex = 0;
      }
    },
    previous: (state, action) => {
      if (state.activeIndex > 0) {
        state.activeIndex -= 1;
      } else {
        state.activeIndex = state.totalMatch - 1;
      }
    },
    setActiveIndex: (state, action) => {
      state.activeIndex = action.payload;
    },
    setTotalMatch: (state, action) => {
      state.totalMatch = action.payload;
    },
    resetCounter: (state, action) => {
      state.activeIndex = 0;
      state.totalMatch = 0;
    },
  },
});

export const {
  setSearchTerm,
  openModal,
  closeModal,
  next,
  previous,
  setTotalMatch,
  resetCounter,
} = findInPageSlice.actions;

export default findInPageSlice.reducer;
